import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { IconRefresh } from "../icons/IconRefresh";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonRetry: React.FC<MprcButtonProps> = ({ text, title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonRetry.text;
    const lTitle = title || theme.buttons.ButtonRetry.title;

    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
            startIcon={<IconRefresh fixedWidth />}
        />
    );
};
